var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlanTip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 20C7.58991 20 4 16.4101 4 12C4 7.58991 7.58991 4 12 4C16.4101 4 20 7.58991 20 12C20 16.4101 16.4101 20 12 20ZM12 21C7.03762 21 3 16.9624 3 12C3 7.03762 7.03762 3 12 3C16.9624 3 21 7.03762 21 12C21 16.9624 16.9624 21 12 21ZM16.8536 9.35355C17.0488 9.15829 17.0488 8.84171 16.8536 8.64645C16.6583 8.45118 16.3417 8.45118 16.1464 8.64645L11 13.7929L8.35355 11.1464C8.15829 10.9512 7.84171 10.9512 7.64645 11.1464C7.45118 11.3417 7.45118 11.6583 7.64645 11.8536L10.6464 14.8536L11 15.2071L11.3536 14.8536L16.8536 9.35355Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanTip);
export default __webpack_public_path__ + "static/media/plan-tip.ad471d6c.svg";
export { ForwardRef as ReactComponent };